/* Generated from docs/design-mockups-v2/assets/essent-slider.js by scripts/port_assets.py.
   Edit the mockup source, not this file. */
/* ==========================================================================
   Essent slider — transform-based, optionally infinite, alignment-aware.
   Becomes theme-dev/assets/essent-slider.js at D2.

   Markup contract
   ---------------
   <div class="carousel carousel--4" data-slider data-align="start|center|end"
        data-loop="true|false">
     <div class="carousel__viewport">
       <div class="carousel__track" data-track>
         <div class="carousel__slide">…</div>
       </div>
     </div>
     <button data-prev>  <button data-next>  <div data-dots>
   </div>

   Slide width comes from CSS (`--per` on the carousel), never from JS, so
   responsiveness stays in the stylesheet. JS only measures.

   Why transform and not native scroll-snap: a scroll container cannot loop
   seamlessly, its arrows dead-end, and `scroll-behavior:smooth` uses the UA's
   easing, so the motion never matches the rest of the design system.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.24,1)';
  var DUR  = 620;

  function Slider(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;

    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var dotsBox = root.querySelector('[data-dots]');

    var align = root.dataset.align || 'start';
    var loop  = root.dataset.loop === 'true';

    var real = Array.prototype.slice.call(track.children);
    var n = real.length;
    if (!n) return;

    var index = 0, slideW = 0, gap = 0, perView = 1, clones = 0;
    var animating = false;

    /* ---- clones -------------------------------------------------------- */
    function buildClones() {
      track.querySelectorAll('[data-clone]').forEach(function (c) { c.remove(); });
      clones = 0;
      if (!loop || n < 2) return;

      measureRaw();
      var need = Math.min(n, Math.ceil(perView) + 1);
      clones = need;

      for (var i = 0; i < need; i++) {
        var head = real[n - 1 - i].cloneNode(true);   // before the first
        var tail = real[i].cloneNode(true);           // after the last
        [head, tail].forEach(function (c) {
          c.setAttribute('data-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.querySelectorAll('a,button,input,select,textarea').forEach(function (f) {
            f.tabIndex = -1;
          });
        });
        track.insertBefore(head, track.firstChild);
        track.appendChild(tail);
      }
    }

    /* ---- measuring -------------------------------------------------------
       Positions come from each slide's own offsetLeft/offsetWidth, never from
       a cached slide width. getBoundingClientRect() reports the *transformed*
       box, and inactive slides are scaled — measuring that way made every step
       ~37px short, so the track drifted and visibly snapped back each cycle.
       offsetLeft is layout geometry: exact, transform-proof, and correct even
       if slides ever differ in width.                                        */
    function viewport() { return root.querySelector('.carousel__viewport'); }

    function measureRaw() {
      gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      slideW = real[0].offsetWidth;
      var vw = viewport().clientWidth;
      perView = slideW > 0 ? Math.max(1, Math.round(vw / (slideW + gap))) : 1;
    }

    function unit() { return slideW + gap; }

    function slotAt(i) {
      var kids = track.children;
      var idx = Math.max(0, Math.min(kids.length - 1, i + clones));
      return kids[idx];
    }

    function offsetFor(i) {
      var el = slotAt(i);
      if (!el) return 0;
      var vw = viewport().clientWidth;
      var x = -(el.offsetLeft - track.children[0].offsetLeft);
      if (align === 'center') return x + (vw - el.offsetWidth) / 2;
      if (align === 'end')    return x + (vw - el.offsetWidth);
      return x;
    }

    /* ---- limits (non-loop) ---------------------------------------------- */
    function maxIndex() {
      if (loop) return n - 1;
      return Math.max(0, n - perView);
    }

    /* ---- painting -------------------------------------------------------- */
    function setX(x, animate) {
      track.style.transition = animate && !reduced
        ? 'transform ' + DUR + 'ms ' + EASE
        : 'none';
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function markActive() {
      var all = Array.prototype.slice.call(track.children);
      all.forEach(function (s) { s.classList.remove('is-active'); });
      var el = all[index + clones];
      if (el) el.classList.add('is-active');
    }

    function paintDots() {
      if (!dotsBox) return;
      var steps = loop ? n : maxIndex() + 1;
      if (steps < 2) { dotsBox.style.display = 'none'; return; }
      dotsBox.style.removeProperty('display');

      if (dotsBox.children.length !== steps) {
        dotsBox.innerHTML = '';
        for (var i = 0; i < steps; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + steps);
          b.addEventListener('click', (function (k) {
            return function () { go(k, true); };
          })(i));
          dotsBox.appendChild(b);
        }
      }
      Array.prototype.forEach.call(dotsBox.children, function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function paintArrows() {
      if (!prevBtn || !nextBtn) return;
      if (loop) { prevBtn.disabled = nextBtn.disabled = false; return; }
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    function paint() { markActive(); paintDots(); paintArrows(); }

    /* ---- movement -------------------------------------------------------- */
    function go(i, animate) {
      if (animating && animate) return;

      if (loop) {
        index = i;                                   // may sit outside 0..n-1
      } else {
        index = Math.max(0, Math.min(maxIndex(), i));
      }

      setX(offsetFor(index), animate);

      if (loop && (index < 0 || index > n - 1)) {
        animating = true;
        var settle = function () {
          track.removeEventListener('transitionend', settle);
          index = (index % n + n) % n;               // wrap into the real range
          setX(offsetFor(index), false);             // silent jump onto the twin
          animating = false;
          paint();
        };
        if (reduced || !animate) { settle(); }
        else { track.addEventListener('transitionend', settle); }
      }

      paint();
    }

    function next() { go(index + 1, true); }
    function prev() { go(index - 1, true); }

    /* ---- pointer drag ---------------------------------------------------- */
    var startX = 0, startY = 0, curX = 0, dragging = false, decided = false, startedAt = 0;

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (animating) return;
      dragging = true; decided = false;
      startX = curX = e.clientX; startY = e.clientY;
      startedAt = Date.now();
      track.style.transition = 'none';
      root.classList.add('is-dragging');
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;

      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        // let the page scroll vertically if that is clearly the intent
        if (Math.abs(dy) > Math.abs(dx)) { dragging = false; root.classList.remove('is-dragging'); return; }
        decided = true;
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      }
      e.preventDefault();
      curX = e.clientX;

      var x = offsetFor(index) + dx;
      if (!loop) {                                   // rubber-band at the ends
        var lo = offsetFor(maxIndex()), hi = offsetFor(0);
        if (x > hi) x = hi + (x - hi) * 0.35;
        if (x < lo) x = lo + (x - lo) * 0.35;
      }
      setX(x, false);
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (!decided) { setX(offsetFor(index), true); return; }

      var dx = curX - startX;
      var speed = Math.abs(dx) / Math.max(1, Date.now() - startedAt);
      var threshold = slideW * 0.28;
      var steps = Math.round(Math.abs(dx) / unit());

      if (Math.abs(dx) > threshold || speed > 0.45) {
        steps = Math.max(1, steps);
        go(index + (dx < 0 ? steps : -steps), true);
      } else {
        go(index, true);
      }
    }

    /* ---- wiring ---------------------------------------------------------- */
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    root.setAttribute('role', 'region');
    root.setAttribute('aria-roledescription', 'carousel');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
    });

    var rt;
    function relayout() {
      buildClones();
      measureRaw();
      if (!loop) index = Math.min(index, maxIndex());
      setX(offsetFor(index), false);
      paint();
    }
    window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(relayout, 140);
    });

    // fonts and lazy images change slide height, not width, but images that
    // arrive late can shift measurement on the first paint
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);

    relayout();
    root.__slider = { go: go, next: next, prev: prev, relayout: relayout };
  }

  // scope lets injected markup (quick view, section re-render) initialise only
  // its own sliders; __slider guards against binding the same root twice
  function init(scope) {
    (scope || document).querySelectorAll('[data-slider]').forEach(function (root) {
      if (!root.__slider) Slider(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.EssentSlider = { init: init };
})();
